const getOrCreateTooltip = (chart) => {
  let tooltipElement = chart.canvas.parentNode.querySelector("div");

  if (!tooltipElement) {
    tooltipElement = document.createElement("div");
    tooltipElement.style.background = "white";
    tooltipElement.style.borderRadius = "3px";
    tooltipElement.style.boxShadow =
      "0px 6px 10px -4px rgba(0, 0, 0, 0.15), 0px 2px 2px rgba(40, 40, 40, 0.1)";
    tooltipElement.style.color = "black";
    tooltipElement.style.width = "auto";
    tooltipElement.style.opacity = 1;
    tooltipElement.style.pointerEvents = "none";
    tooltipElement.style.position = "absolute";
    tooltipElement.style.transform = "translate(-50%, 0)";
    tooltipElement.style.transition = "all .1s ease";

    const table = document.createElement("table");
    table.style.margin = "0px";

    tooltipElement.appendChild(table);
    chart.canvas.parentNode.appendChild(tooltipElement);
  }

  return tooltipElement;
};

export const deviceTooltipHandler = (context) => {
  const label = context.tooltip.dataPoints[0].label;
  const data = context.tooltip.dataPoints[0].dataset.data;
  const colors = context.tooltip.dataPoints[0].dataset.backgroundColor;
  const dataIndex = context.tooltip.dataPoints[0].dataIndex;

  const totalDevices = context.tooltip.dataPoints[0].dataset.totalDevices;

  // Tooltip Element
  const { chart, tooltip } = context;
  const tooltipElement = getOrCreateTooltip(chart);

  // Hide if no tooltip
  if (tooltip.opacity === 0) {
    tooltipElement.style.opacity = 0;
    return;
  }

  // Set Text
  if (tooltip.body) {
    const table = tooltipElement.querySelector("table");

    const firstRow = document.createElement("tr");
    const colorElement = document.createElement("td");

    const titleElement = document.createElement("td");
    titleElement.setAttribute("colspan", "2");
    titleElement.textContent = label;

    const span = document.createElement("span");

    span.style.background = colors[dataIndex];
    span.style.borderWidth = "2px";
    span.style.borderRadius = "50%";
    span.style.marginRight = "5px";
    span.style.width = "10px";
    span.style.height = "10px";
    span.style.display = "block";

    colorElement.appendChild(span);
    firstRow.appendChild(colorElement);
    firstRow.appendChild(titleElement);

    const secondRow = document.createElement("tr");
    const space = document.createElement("td");

    const valueContainer = document.createElement("td");
    const percentElement = document.createElement("span");
    percentElement.style.marginRight = "5px";
    percentElement.style.fontWeight = 500;
    percentElement.textContent = `${data[dataIndex]}%`;

    const valueElement = document.createElement("span");
    valueElement.textContent = `(${totalDevices[dataIndex]})`;
    valueElement.style.fontWeight = 500;

    secondRow.appendChild(space);
    valueContainer.appendChild(percentElement);
    valueContainer.appendChild(valueElement);
    secondRow.appendChild(valueContainer);

    // Remove old children
    while (table.firstChild) {
      table.firstChild.remove();
    }

    // Add new children
    table.appendChild(firstRow);
    table.appendChild(secondRow);
  }

  const { offsetLeft: positionX, offsetTop: positionY } = chart.canvas;

  // Display, position, and set styles for font
  tooltipElement.style.opacity = 1;
  tooltipElement.style.left = positionX + tooltip.caretX + "px";
  tooltipElement.style.top = positionY + tooltip.caretY + "px";
  tooltipElement.style.font = tooltip.options.bodyFont.string;
  tooltipElement.style.padding =
    tooltip.options.padding + "px " + tooltip.options.padding + "px";
};
